import tool from 'toolLoaderPC';
import validate from 'validate';
import dialog from 'dialog';
import ajax from 'ajax';
import avalon from 'avalon';
var hiddenValues; // 本页面隐藏域
var addressUnWatch; // 地址监控
var currentEditingAddress;
var location = window.GLOBAL_LOCATION;
var countFinalPriceDeffered = null;

function _resetAddress () {
    if (currentEditingAddress) {
        vmodel.recieveName = currentEditingAddress.name;
        vmodel.recievePhone = currentEditingAddress.mobile;
        vmodel.recieveAddress = currentEditingAddress.address;
        vmodel.recieveProvince = currentEditingAddress.province_id;
        vmodel.recieveCity = currentEditingAddress.city_id;
        vmodel.recieveArea = currentEditingAddress.district_id;
    } else {
        vmodel.provinces = location;
        vmodel.recieveProvince = location[0].id;
        vmodel.recieveName = ''; // 收货人姓名
        vmodel.recieveNameTips = ''; // 收货人姓名错误提示
        vmodel.recievePhone = ''; // 收货人手机号码
        vmodel.recievePhoneTips = ''; // 收货人手机号码错误提示
        vmodel.recieveAddress = ''; // 收货人详细信息
        vmodel.recieveAddressTips = ''; // 收货人详细信息错误提示
    }
    vmodel.recieveNameTips = '';
    vmodel.recievePhoneTips = '';
    vmodel.recieveAddressTips = '';
}

var vmodel = avalon.define({
    $id: 'orderConfirmController',
    list: [], // 商品信息
    allMoney: '', // 总金额
    allFreight: '', // 总运费
    finalFreight: '', // 优惠后最终运费
    cut_money: '0.00', // 优惠的金额
    usable_voucher: 0, // 可以使用的代金券金额
    finalMoney: '', // 优惠后最终金额
    remark: '', // 订单备注
    remarkPlaceholder: '', // 新加的备注输入框的placeholder
    promotiong: '', // 促销金额
    cod_promotiong: '', // 促销金额 返现

    canUseVoucher: false, // 是否可以使用代金券
    usedVoucher: [], // 是否使用了代金券，avalon的CheckBox必须是数组

    isCod: false, // 是否支持货到付款
    payOption: 'online', // 收货方式 'online' 在线付款 'cod' 货到付款

    member_address: [], // 收货信息列表
    choosedAddress: '', // 选择的地址的id

    addressAdder: false, // 地址编辑框是否显示
    recieveName: '', // 收货人姓名
    recieveNameTips: '', // 收货人姓名错误提示
    recievePhone: '', // 收货人手机号码
    recievePhoneTips: '', // 收货人手机号码错误提示
    recieveAddress: '', // 收货人详细信息
    recieveAddressTips: '', // 收货人详细信息错误提示
    recieveProvince: '', // 收货人所在省
    provinces: [], // 所有省
    recieveCity: '', // 收货人所在城市
    citys: [], // 所有市
    recieveArea: '', // 收货人所在区域
    areas: [], // 所有区
    saveRecieveLoading: false, // 保存收货人地址中...

    /**
     * 埋点数据统计
     */
    sendEventTracking: function (n, param) {
        tool.sendEventTracking('pc', n, param);
    },

    /**
     * 选择收货地址
     */
    changeAddress: function () {
        vmodel.countFinalPrice();
    },

    /**
     * 新增收货地址
     */
    addAddress: function () {
        currentEditingAddress = null;
        _resetAddress();
        vmodel.addressAdder = true;
    },

    /**
     * 编辑收货地址
     */
    editAddress: function (address) {
        currentEditingAddress = address;
        _resetAddress();
        vmodel.addressAdder = true;
    },

    /**
     * 删除收货地址
     */
    deleteAddress: function (address) {
        dialog.confirm('删除不能恢复，确认删除吗？', function () {
            vmodel.member_address.remove(address);
            ajax.getWithFail('delete_address.html', { id: address.id });
            if (vmodel.choosedAddress === address.id) {
                if (vmodel.member_address.length) {
                    vmodel.choosedAddress = vmodel.member_address[0].id;
                } else {
                    vmodel.choosedAddress = '';
                }
            }
            vmodel.countFinalPrice();
        });
    },

    /**
     * 关闭地址编辑框
     */
    returnToList: function () {
        vmodel.addressAdder = false;
        currentEditingAddress = null;
    },

    /**
     * 省市区编辑器 省级输入框改变
     */
    proinceChange: function (id) {
        var provinces = vmodel.provinces;

        $.each(provinces, function (index, province) {
            if (id === province.id) {
                vmodel.citys = province.city;
                vmodel.recieveCity = province.city[0].id;
                return false;
            }
        });

        // if (currentEditingAddress) {
        //     vmodel.recieveCity = currentEditingAddress.city_id;
        // }
    },

    /**
     * 省市区编辑器 市级输入框改变
     */
    cityChange: function (id) {
        var citys = vmodel.citys;

        $.each(citys, function (index, city) {
            if (id === city.id) {
                vmodel.areas = city.area;
                vmodel.recieveArea = city.area[0].id;
                return false;
            }
        });

        // if (currentEditingAddress) {
        //     vmodel.recieveArea = currentEditingAddress.district_id;
        // }
    },

    /**
     * 保存收货人地址
     */
    saveRecieve: function () {
        var recieveNameValid = validate.valid(vmodel.recieveName, {
            required: { error: '收货人姓名不能为空' }
        });
        var recievePhoneValid = validate.valid(vmodel.recievePhone, {
            required: { error: '收货人手机号码不能为空' },
            mobilephohe: { error: '收货人手机格式不对' }
        });
        var recieveAddressValid = validate.valid(vmodel.recieveAddress, {
            required: { error: '收货人详细地址不能为空' },
            lengthMaxEqual: {
                value: 100,
                error: '您输入的字数已超过限制'
            }
        });
        if (
            recieveNameValid === true &&
            recievePhoneValid === true &&
            recieveAddressValid === true
        ) {
            vmodel.saveRecieveLoading = true;
            var postData = {
                name: vmodel.recieveName,
                province: vmodel.recieveProvince,
                city: vmodel.recieveCity,
                district: vmodel.recieveArea,
                address: vmodel.recieveAddress,
                tel: vmodel.recievePhone
            };
            if (currentEditingAddress) {
                postData.id = currentEditingAddress.id;
                ajax.postWithFail('/update_address.html', postData)
                    .done(function (response) {
                        $.extend(
                            currentEditingAddress,
                            response.msg[postData.id]
                        );
                        vmodel.saveRecieveLoading = false;
                        vmodel.addressAdder = false;
                        currentEditingAddress = null;
                    })
                    .fail(function () {
                        vmodel.saveRecieveLoading = false;
                    });
            } else {
                ajax.postWithFail('/add_address.html', postData)
                    .done(function (response) {
                        vmodel.member_address.removeAll();
                        for (var i in response.msg) {
                            vmodel.member_address.push(response.msg[i]);
                        }
                        vmodel.saveRecieveLoading = false;
                        vmodel.addressAdder = false;
                    })
                    .fail(function () {
                        vmodel.saveRecieveLoading = false;
                    });
            }
        } else {
            vmodel.recieveNameTips =
                recieveNameValid === true ? '' : recieveNameValid;
            vmodel.recievePhoneTips =
                recievePhoneValid === true ? '' : recievePhoneValid;
            vmodel.recieveAddressTips =
                recieveAddressValid === true ? '' : recieveAddressValid;
        }
        vmodel.countFinalPrice();
    },

    /**
     * 根据所选条件，结算价格
     */
    countFinalPrice: function () {
        var isUse = vmodel.usedVoucher.length;
        var skus = hiddenValues.skus.join('_');
        countFinalPriceDeffered && countFinalPriceDeffered.request.abort();
        countFinalPriceDeffered = ajax
            .getWithFail('/order/default/use-voucher.html', {
                skus: skus,
                isUse: isUse,
                is_cod: vmodel.payOption === 'cod' ? 1 : 0,
                address_id: vmodel.choosedAddress
            })
            .done(function (response) {
                if (response.type == 'succ') {
                    vmodel.promotiong = response.msg.promotion_amount;
                    vmodel.real_amount = response.msg.real_amount;
                    vmodel.finalFreight = response.msg.delivery_amount;
                    vmodel.finalMoney = vmodel.real_amount;
                } else {
                    dialog.alert('提示', response.msg);
                }
            });
    },

    /**
     * 切换支付方式
     */
    selectPayOption: function (type) {
        vmodel.payOption = type;
        if (type === 'cod') {
            // 货到付款
            vmodel.usedVoucher = [];
            dialog.alert(
                '货到付款将无法使用代金券，且不参与任何线上优惠活动哦~',
                '是否选择货到付款？'
            );
        } else {
            // 如果可使用代金券 默认勾选上使用
            if (vmodel.canUseVoucher) {
                vmodel.usedVoucher = ['1'];
            }
        }
        vmodel.countFinalPrice();
    },

    pay: function () {
        if (vmodel.choosedAddress === '') {
            vmodel.sendEventTracking(10901);
            dialog.alert('请选择收货人信息');
            tool.scrollTo($('#order-confirm .locations').parent());
        } else {
            tool.singleWay('order-confirm-pay', function (key) {
                var kit = this;
                vmodel.sendEventTracking(10900, {
                    goodslist: hiddenValues.skus.join('_')
                });
                ajax.post('order_create.html', {
                    address_id: vmodel.choosedAddress,
                    skus: hiddenValues.skus.join('_'),
                    vouchers: vmodel.usedVoucher.length ? 1 : 0,
                    channel_id: vmodel.payType,
                    remark: vmodel.remark,
                    is_cod: vmodel.payOption === 'cod' ? 1 : 0
                })
                    .done(function (response) {
                        if (response.type == 'err') {
                            return dialog.confirm(
                                response.msg,
                                function () {
                                    ajax.pjax('/cart_list.html');
                                },
                                function () {
                                    ajax.pjax('/cart_list.html');
                                }
                            );
                        }
                        ajax.pjax(response.url);
                    })
                    .fail(function () {
                        kit.resolve(key);
                    });
            });
        }
    }
});

window.vmodel = vmodel;

export default {
    init: function () {
        console.log(dialog);
        hiddenValues = tool.getHiddenValues('#js-local-hiddens');
        console.log(hiddenValues);
        // 是否支持货到付款
        vmodel.isCod = hiddenValues.isCod === '1';

        hiddenValues.fee.usable_voucher = tool.toNumber(
            hiddenValues.fee.usable_voucher
        );
        $.each(hiddenValues.cart_list, function (i, group) {
            group.restrict = !(
                tool.toNumber(group.time_restrict) === 0 &&
                tool.toNumber(group.ip_restrict) === 0
            ); // 组商品是否限购
            group.count = 0; // 组商品所购数量
            group.count2 = 0;
            //				group.max_voucher = tool.toNumber(group.max_voucher);			// 该组商品最多能使用多少优惠券
            //				group.min_voucher = tool.toNumber(group.min_voucher);			// 该组商品最少能使用多少优惠券
            //				group.useVouchers = false;										// 该组商品是否使用了优惠券
            //				group.canUseVouchers = group.max_voucher > 0 && hiddenValues.fee.usable_voucher > 0;	// 该组商品是否可使用优惠券
            //				group.usedVouchers = 0;											// 该组商品使用的优惠券
            //				group.usedVouchersForMoney = tool.toMoney(0);					// 该组商品使用优惠券抵用的金额

            var _groupMoney = 0; // 组总金额
            var _noDiscountGroupMoney = 0; // 不享受优惠的价格
            $.each(group.sku, function (j, goods) {
                var _nums = tool.toNumber(goods.buy_num);
                var _price = tool.toNumber(goods.shop_price);
                group.count += _nums;
                goods.total = tool.toMoney(_nums * _price);
                _groupMoney += parseFloat(goods.total);
            });
            $.each(group.sku, function (j, goods) {
                var _nums = tool.toNumber(goods.buy_num);
                var _price = tool.toNumber(goods.shop_origin_price);
                group.count2 += _nums;
                goods.total2 = tool.toMoney(_nums * _price);
                _noDiscountGroupMoney += parseFloat(goods.total2);
            });
            group.total = tool.toMoney(_groupMoney);
            group.total2 = tool.toMoney(_noDiscountGroupMoney);
        });

        currentEditingAddress = null;
        _resetAddress(); // 重置收货人信息输入框

        var fee = hiddenValues.fee;
        tool.setVMValues(vmodel, {
            allMoney: fee.sku_amount, // 商品总价
            finalMoney: fee.real_amount, // 合计最终支付价格
            finalFreight: fee.delivery_amount, // 运费合计
            cut_money: fee.favorable_amount, // 优惠合计
            list: hiddenValues.cart_list, // 绑定商品信息
            canUseVoucher: fee.usable_voucher > 0,
            usable_voucher: tool.toNumber(fee.usable_voucher).toFixed(2), // 拥有的优惠券
            member_address: hiddenValues.member_address, // 地址列表
            promotiong: fee.promotion_amount, // 促销金额,
            remarkPlaceholder: hiddenValues.remark || '还想对商家叮嘱什么..'
        });

        // 如果可使用代金券 默认勾选上使用
        if (vmodel.canUseVoucher) {
            vmodel.usedVoucher[0] = '1';
        }

        addressUnWatch = vmodel.$watch('recieveAddress', function (address) {
            var l = address.length;
            if (l <= 100) {
                vmodel.recieveAddressTips = '您还能输入' + (100 - l) + '个字';
            } else {
                vmodel.recieveAddressTips = '您输入的字数已超过限制';
            }
        });

        // 获取一次价格
        vmodel.countFinalPrice();
    },
    clear: function () {
        addressUnWatch && addressUnWatch();
        vmodel.choosedAddress = '';
        vmodel.choosedCoupon = '';
        vmodel.cut_money = '0.00';
    }
};



// WEBPACK FOOTER //
// ./src/js_modules/orderConfirmController.js